import { z } from 'zod'

export const UserSchema = z.object({
  id: z.string().uuid('validation:uuidInvalid').optional(),
  email: z.string().email('validation:emailInvalid'),
  password: z.string().min(8, 'validation:passwordMin'),
  features: z.array(z.string()),
  created_at: z.date().optional(),
})

export type User = z.infer<typeof UserSchema>
